import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { agentChatStyles as styles } from "./styles";

/** After this long with no word from the agent, the label says the wait is longer than usual. */
const STILL_WORKING_AFTER_MS = 8000;

/**
 * The agent's "typing" line: three pulsing dots and a label that names the step
 * (thinking, looking something up, still working). Shown before the first word of a
 * reply and whenever a lookup runs mid-reply. Announced to screen readers per label
 * change; the dots are decorative and still under reduced motion.
 *
 * @param {{ phase?: "thinking" | "lookingUp" }} props
 */
export default function AgentThinking({ phase = "thinking" }) {
  const { t } = useTranslation("agent");
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), STILL_WORKING_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  const label = phase === "lookingUp" ? t("lookingUp") : slow ? t("stillWorking") : t("thinking");

  return (
    <Box sx={styles.thinking} role="status" aria-live="polite">
      <Box component="span" sx={styles.thinkingDots} aria-hidden>
        {[0, 1, 2].map((i) => (
          <Box key={i} component="span" sx={styles.thinkingDot(i)} />
        ))}
      </Box>
      <Typography component="span" sx={styles.thinkingText} dir="auto">
        {label}
      </Typography>
    </Box>
  );
}
